export default {
    red: '#ff4778',
    purple: '#7633ff',
    white: '#ffffff',
    purpleRgba08: 'rgba(118, 51, 255, 0.08)',
    purpleRgba16: 'rgba(118, 51, 255, 0.16)',
    purpleRgba24: 'rgba(118, 51, 255, 0.24)',
    purpleRgba40: 'rgba(118, 51, 255, 0.4)',
    whiteRgba24: 'rgba(255, 255, 255, 0.24)',
    whiteRgba48: 'rgba(255, 255, 255, 0.48)',
    whiteRgba64: 'rgba(255, 255, 255, 0.64)',
    whiteRgba72: 'rgba(255, 255, 255, 0.72)',
    whiteRgba96: 'rgba(255, 255, 255, 0.96)',
    greyRgba28: 'rgba(159, 157, 163, 0.28)',
    wildWatermelon08: 'rgba(255, 71, 120, 0.08)',
    lightGrayShadow: 'rgba(157, 161, 163, 0.24)',
    porcelain: '#f4f6f7',
    codGray04: 'rgba(20, 20, 20, 0.04)',
    codGray12: 'rgba(20, 20, 20, 0.12)',

    // used in old landing
    baseColor: '#141414',
    mediumGray: '#77767a',
    lightGray: '#9f9da3',
    superLightGray: '#f3f2f5',
    superLightPurple: '#d9c6ff',
};
